import React from 'react'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: 'wheat',
    backgroundImage: 'url(paper2.png)',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  }
}));

export default function OldPaper(props) {
  const css = useStyles()
  return <div className={`${css.paper} ${props.className}`}>
    {props.children}
  </div>
}